<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('common.text00100') }}</div>
    <div slot="body">
      <img :style="{ width: '100%' }" :src="img" />
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'OverViewDialog',
  mixins: [DialogMixin, WindowsMixin],
  computed: {
    img () {
      const { type = 'overview' } = this.params
      return require(`../assets/${type}.png`)
    },
  },
}
</script>
